export default "__VITE_ASSET__DTQgBSAH__"